import { render, staticRenderFns } from "./BtnAtivarDesativarItemManutencao.vue?vue&type=template&id=406db3e4&"
import script from "./BtnAtivarDesativarItemManutencao.vue?vue&type=script&lang=js&"
export * from "./BtnAtivarDesativarItemManutencao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports